<div class="section">
  <div class="title" i18n="@@addDogAndManage">Aggiungi amico fedele da gestire</div>
  <form #assignAmicoFedeleForm="ngForm" (ngSubmit)="assignAmicoFedele()">
    <div class="card">
      <div class="card-content fix-horizontal-form">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@memberIdUpperDog" >Id Socio</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="idSocio" type="number" min="0" max="2147483647" required name="idSocioField">
              </div>
              <p class="help is-danger" *ngIf="assignAmicoFedeleForm.submitted && !idSocio" i18n="@@dataRequired" >
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@chip">Chip</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="chip" type="text" required name="chipField" >
              </div>
              <p class="help is-danger" *ngIf="assignAmicoFedeleForm.submitted && !chip" i18n="@@dataRequired" >
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field has-text-right">
          <div class="control has-text-right">
            <button type="submit" class="button is-link" i18n="@@assign" >Assegna</button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <form #addAmicoFedeleForm="ngForm" (ngSubmit)="addAmicoFedele()">
    <div class="card">
      <div class="card-content fix-horizontal-form">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" [ngClass]="{'has-text-danger' : nomeField.invalid && (nomeField.dirty || nomeField.touched || addAmicoFedeleForm.submitted)}"
                   i18n="@@name" >Nome</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="amicoFedele.nome" name="amicoFedeleName"
                       required type="text" #nomeField="ngModel" [ngClass]="{'is-danger' : nomeField.invalid && (nomeField.dirty || nomeField.touched || addAmicoFedeleForm.submitted)}">
              </div>
              <p class="help is-danger" *ngIf="nomeField.invalid && (nomeField.dirty || nomeField.touched || addAmicoFedeleForm.submitted)"
                 i18n="@@dataRequired" >
                Dato richiesto
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label"
                   [ngClass]="{'has-text-danger' : chipField.invalid && (chipField.dirty || chipField.touched || addAmicoFedeleForm.submitted)}">Chip</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="amicoFedele.chip" name="amicoFedeleChip"
                       required type="text" #chipField="ngModel" [ngClass]="{'is-danger' : chipField.invalid && (chipField.dirty || chipField.touched || addAmicoFedeleForm.submitted)}">
              </div>
              <p class="help is-danger" *ngIf="chipField.invalid && (chipField.dirty || chipField.touched || addAmicoFedeleForm.submitted)"
                 i18n="@@dataRequired" >
                Dato richiesto
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@breed" 
                   [ngClass]="{'has-text-danger' : razzaField.invalid && (razzaField.dirty || razzaField.touched || addAmicoFedeleForm.submitted)}">Razza</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="amicoFedele.razza" name="amicoFedeleRazza"
                       required type="text" #razzaField="ngModel" [ngClass]="{'is-danger' : nomeField.invalid && (razzaField.dirty || razzaField.touched || addAmicoFedeleForm.submitted)}">
              </div>
              <p class="help is-danger" *ngIf="razzaField.invalid && (razzaField.dirty || razzaField.touched || addAmicoFedeleForm.submitted)"
                 i18n="@@dataRequired" >
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-grouped field is-grouped-right">
          <div class="control">
            <a [routerLink]="['/area-utente', 'gruppo']" class="button is-danger" i18n="@@cancel">Annulla</a>
          </div>
          <div class="control">
            <button type="submit" class="button is-primary" i18n="@@create">Crea</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
